<template>
  <div class="row mt-3 mx-0" v-if="settings.display_personalized_message">
    <div class="col-12">
      <div class="intro-msg" v-bind:style="{ background: settings.message_background_color }">
        <p class="mb-0" v-bind:style="{ color: settings.message_text_color }" v-html="settings.personalized_message"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserPeronalizedMessage",
  props: ["setting"],
  data() {
    return {
      settings: null,
    };
  },
  created() {
    if (!this.setting) {
      this.settings = this.$session.get("response").settings;
    } else {
      this.settings = this.setting;
    }
  }
};
</script>

<style scoped lang="scss">
.intro-msg {
  padding: 8px 16px;
  background: #2aa6ff;
  border-radius: 15px 15px 15px 0px;
  p {
    font-family: "Mulish", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #ffffff;
    text-align: left;
  }
}
</style>
